import { EditPageGeneralInfo, PageDataSourceSettings } from "../../components"

import { FC } from "react"
import { IPage } from "../../../models"

interface IPageSettingsProps {
    page: IPage,
    onChange: (page: IPage) => void,
}

export const PageSettings: FC<IPageSettingsProps> = ({ page, onChange }) => {
    return (
        <>
            <EditPageGeneralInfo
                page={page}
                onChange={onChange} />
            <PageDataSourceSettings
                page={page}
                onChange={onChange} />
        </>
    )
}
